import React from "react";
import { BsDot } from "react-icons/bs";
import { Link } from "react-router-dom";
import { ResponceMain } from "../OptionRes/ResStyles";

const ContactRes = () => {
  return (
    <ResponceMain>
      <div className="space-between">
        <h3>Contact Us</h3>
      </div>
      <p>
        Our team is gracefully waiting for your queries & responce of Money
        Manger software please fill the contact form we will revert you back.
      </p>
      <Link to="/contact-us">
        <div className="button">See Details</div>
      </Link>
    </ResponceMain>
  );
};

export default ContactRes;
